import axios from "axios";
import { useState, useEffect } from "react";
import { DateRangePicker } from "react-date-range";
import {BarChart,Bar,Cell,XAxis,Tooltip,ResponsiveContainer,LabelList} from "recharts";

const CityGraph = () => {
  const baseAPI = process.env.REACT_APP_API_URL;
  const [CityData, setCityData] = useState([]);
  const [colors, setColors] = useState({});
  const [isCityPicker, setIsCityPicker] = useState(false);
  const [dateRangeStage, setDateRangeStage] = useState("Select Date Range");

  const [selectionCity, setSelectionCity] = useState({
    startDate: null,
    endDate: null,
    key: "selection",
  });

  const tableHeaderStylegraph = {
    border: "1px solid #ddd",
    padding: "8px",
    textAlign: "center",
    backgroundColor: "#f4f4f4",
    fontWeight: "bold",
  };

  const tableCellStylegraph = {
    border: "1px solid #ddd",
    padding: "8px",
    textAlign: "center",
  };



  function generateColors(CityData) {
    const colorMapping = {};
    CityData.forEach((item) => {
      if (!colorMapping[item.cityname]) {
        const randomColor =
          "#" +
          Math.floor(Math.random() * 16777215)
            .toString(16)
            .padStart(6, "0");
        colorMapping[item.cityname] = randomColor;
      }
    });
    return colorMapping;
  }
 
  const fetchDefaultCityData = async () => {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    const response = await axios.get(
      `${baseAPI}userget/getdashboarddetailCountry?startDate=&endDate=`,
      {
        headers: {
          Authorization: `Bearer ${storedToken}`,
        },
      }
    );

    if (response && response.data && response.data.data.byCity) {
      setColors(generateColors(response.data.data.byCity)); 
      setCityData(response.data.data.byCity);
      setSelectionCity({
        startDate: new Date(),
          endDate: new Date(),
          key: "selection",
      });
    }
  };

  useEffect(() => {
    fetchDefaultCityData(); 
  }, []);

  const handleSelectCity = (ranges) => {
    const { startDate, endDate } = ranges.selection;
    setSelectionCity({
      startDate: startDate,
      endDate: endDate,
      key: "selection",
    });
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    const options = { day: "2-digit", month: "short", year: "numeric" };
    return date.toLocaleDateString("en-US", options);
  }

  const fetchCityData = async () => {
    const storedToken = JSON.parse(localStorage.getItem("token"));

      let cdate = formatDate(new Date());
    let startdate = selectionCity.startDate
      ? formatDate(selectionCity.startDate)
      : "";
    let enddate = selectionCity.endDate
      ? formatDate(selectionCity.endDate)
      : "";

      if (startdate === cdate && enddate === cdate) {
        setDateRangeStage("Select Date Range");
        startdate = "";
        enddate = "";
      } else {
        setDateRangeStage(startdate + " - " + enddate);
      }

    const apiUrl = `${baseAPI}userget/getdashboarddetailCountry?startDate=${startdate}&endDate=${enddate}`;

    const response = await axios.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${storedToken}`,
      },
    });

    if (response && response.data && response.data.data.byCity) {
      setCityData(response.data.data.byCity); // Update the state with country data
      setColors(generateColors(response.data.data.byCity)); // Generate dynamic colors
      setIsCityPicker(false); // Close Date Picker after apply
    }
  };

  return (
    <>
     <div
      style={{
        backgroundColor: "#fff",
        textAlign: "left",
        width: "50%",
        borderTopRightRadius:"17px",
        borderBottomRightRadius:"17px",
      }}
    >
      <div
        className="outerFilterLeadStage"
        style={{ gap: "1rem", marginBottom: "1rem", display: "flex",justifyContent: "flex-start" }}
      >
        <div className="innerFilterLead" style={{ gap: "20px", marginLeft: "2rem", marginTop: "1rem" }}>
          <div className="filter-icon-stage">
            <img src={require("../../../Icons/filterIcon.png")} alt="filter" />
            FILTER
          </div>

          <button
            style={{
              marginBottom: "7px",
              width: "10rem",
              height: "2.5rem",
              borderRadius: "0.5rem",
              fontSize: "11px",
            }}
            onClick={() => setIsCityPicker(!isCityPicker)}
          >
            <b>{dateRangeStage}</b>
          </button>

          {isCityPicker && (
            <div
              style={{
                position: "absolute",
                zIndex: 999,
                border: "solid 1px black",
                marginLeft: "-5pc",
                width: "35pc",
                background: "white",
                marginTop: "1rem",
              }}
            >
              <DateRangePicker
                ranges={[selectionCity]}
                onChange={handleSelectCity}
              />
              <button
                style={{
                  marginBottom: "1rem",
                    width: "8rem",
                    height: "2.5rem",
                    borderRadius: "0.5rem",
                    fontSize: "13px",
                    position: "relative",
                    top: "1px",
                    left: "16pc",
                    backgroundColor: "#5B489D",
                    color: "White",
                    border: "none",
                }}
              onClick={fetchCityData}>Apply Filter</button>
              <button
               style={{
                marginBottom: "1rem",
                width: "7.5rem",
                height: "2.5rem",
                borderRadius: "0.5rem",
                fontSize: "13px",
                position: "relative",
                top: "1px",
                left: "17pc",
                color: "red",
                backgroundColor: "white",
                border: "none",
                fontWeight: "bold",
              }}
              
              onClick={() => setIsCityPicker(false)}>Close</button>
            </div>
          )}

          <button
            style={{
              marginBottom: "7px",
              width: "8rem",
              height: "2.5rem",
              borderRadius: "0.5rem",
              fontSize: "13px",
              top: "1px",
              left: "16pc",
              backgroundColor: "#5B489D",
              color: "White",
              border: "none",
              marginLeft: "10px",
            }}
            onClick={fetchCityData}
          >
            Apply
          </button>
        </div>
      </div>
      <hr />

      {/* Table Section */}
      <div
        style={{
          padding: "20px",
          backgroundColor: "#fff",
          borderRadius: "8px",
          textAlign: "left",
        }}
      >
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th style={tableHeaderStylegraph}>City</th>
              <th style={tableHeaderStylegraph}>Booking</th>
              <th style={tableHeaderStylegraph}>Execution</th>
              <th style={tableHeaderStylegraph}>Cancelled</th>
            </tr>
          </thead>
          <tbody>
            {CityData.map((item, index) => (
              <tr key={index}>
                <td style={tableCellStylegraph}>{item.cityname}</td>
                <td style={tableCellStylegraph}>{item.totalbooking}</td>
                <td style={tableCellStylegraph}>{item.execution}</td>
                <td style={tableCellStylegraph}>{item.cancelled}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>



      <ResponsiveContainer width="100%" height={400}>
        <BarChart
          width={600}
          height={400}
          data={CityData}
          margin={{ top: 30, right: 30, left: 20, bottom: 5 }}
        >
          <XAxis 
            dataKey="cityname" 
            tickFormatter={(cityname) => cityname}
            tick={({ x, y, payload }) => {
              const cityColor = colors[payload.value]; // Get the color for the cityname
              return (
                <text
                  x={x}
                  y={y + 15} // Adjust the Y position for better alignment
                  fill={cityColor || "#000"}
                  textAnchor="middle"
                  style={{ fontSize: 14, fontWeight: "bold" }}
                >
                  {payload.value}
                </text>
              );
            }}
          />
          <Tooltip />
          <Bar
            dataKey="execution_percentage_overall_city"
            fill="#8884d8"
            barSize={50}
            isAnimationActive={true}
          >
            <LabelList dataKey="execution_percentage_overall_city" position="top" formatter={(value) => `${value}%`} />
            {CityData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={colors[entry.cityname] || "#8884d8"} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
 
    </div>
    <style jsx>{`
      .filter-icon-stage {
    box-shadow: 0 1px 8px rgba(0, 0, 0, 0.25);
    width: 87px;
    height: 104%;
    position: relative;
    padding: 9px;
    padding-top: 16px;
    background-color: white;
    border-radius: 9px;
   top: -4px !important;
    left: -29px;
    font-size: 12px;
}
      `}</style>
    </>
   
  );
};

export default CityGraph;
